var React = require('react');

function ContentEnvelope (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.3,0C3.2,0,0,3.4,0,7.6v7.6l317.4,238.1L634.8,15.1v-7.6C634.8,3.4,631.6,0,627.5,0H7.3ZM0,52.9v319.5l191.5-175.9L0,52.9ZM634.8,52.9l-191.5,143.6,191.5,175.9V52.9ZM216.3,214.9L22.2,393h590.4l-194.1-178.1-92.1,69.2c-2.6,1.9-5.7,3-9,3s-6.4-1-9-3l-92.1-69.2Z"}));
}

ContentEnvelope.defaultProps = {"version":"1.1","viewBox":"0 0 634.8 393"};

module.exports = ContentEnvelope;

ContentEnvelope.default = ContentEnvelope;
